module.exports = __webpack_public_path__ + "static/img/logo.4443c240.png";